import { render } from "./CountIndicator.vue?vue&type=template&id=9c651e18&scoped=true"
import script from "./CountIndicator.vue?vue&type=script&lang=js"
export * from "./CountIndicator.vue?vue&type=script&lang=js"

import "./CountIndicator.vue?vue&type=style&index=0&id=9c651e18&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c651e18"]])

export default __exports__